module.exports = __webpack_public_path__ + "assets/img/trade-list@2x.f0df4fc5.png";